// extracted by css-extract-rspack-plugin
export default {"Description":"WNaOE","EmptyDescription":"HnAhH"};